import httpHelper from '../../../utils/httpHelper';
import { appConfig } from '../../../constants/appConfig';

export const authService = {
  async token(payload) {
    const result = await httpHelper.makePostRequest(
      appConfig.tokenUrl,
      '/token',
      payload,
    );
    return result;
  },

  async login(path, payload) {
    const endPoint = `/user-account/findByUserId/${payload.username}`;
    const result = await httpHelper.makeGetRequest(
      path,
      endPoint,
      {},
      'Bearer',
    );
    return result;
  },

  async getTokenForInstance(payload) {
    const result = await httpHelper.makePostRequest(
      appConfig.tokenUrl,
      '/auth',
      payload,
    );
    return result;
  },
  async getInstanceIdByYerlemId(payload) {
    const result = await httpHelper.makeGetRequest(
      appConfig.kimlik,
      `/app-instance-id-relation/findByYidId`,
      payload,
      'instanceToken',
    );
    return result;
  },

  async getPermissions(path, payload) {
    const userRoleEndPoint = `/user-role/findAllByUserId/${payload}`;
    const resultRole = await httpHelper.makeGetRequest(
      path,
      userRoleEndPoint,
      {},
      'Bearer',
    );
    console.log(payload);
    console.log(resultRole);
    const roleId = resultRole?.data?.data[0]?.role.id;

    const permissionEndPoint = `/role-permission/findAllByRoleId/${roleId}`;
    const resultPermissions = await httpHelper.makeGetRequest(
      path,
      permissionEndPoint,
      {},
      'Bearer',
    );

    return resultPermissions;
  },

  async getRBAC(appPath, uname) {
    const path = `/rbac-graph/query/user/${uname}`;
    const payload = await httpHelper.makeGetRequest(
      appPath,
      path,
      {},
      'Bearer',
    );
    return payload;
  },

  async getPermissionByRoleId(path, roleId) {
    const permissionEndPoint = `/role-permission/findAllByRoleId/${roleId}`;
    const resultPermissions = await httpHelper.makeGetRequest(
      path,
      permissionEndPoint,
      {},
      'Bearer',
    );

    return resultPermissions;
  },

  async isObserver(path, userId) {
    const endPoint = `at/observer/findByUserId/${userId}`;
    const result = await httpHelper.makeGetRequest(
      path,
      endPoint,
      {},
      'Bearer',
    );
    return result;
  },
  async getUser(path, userId) {
    const endPoint = `user/${userId}`;
    const result = await httpHelper.makeGetRequest(
      path,
      endPoint,
      {},
      'Bearer',
    );
    return result;
  },
};
